<template>
    <div class="main_index">
        <div class="main_back_div">
            <img src="../../../assets/image/custom/main_index_bg.jpg" class="main_back_img"/>
            <template v-for="item in picData">
                <div @mouseenter="toggleColor(item.hoverType, true)" @mouseleave="toggleColor(item.hoverType, false)" :class="[hoverType == item.hoverType ? item.staticClass : item.hoverClass]" :style="`position: absolute;top:${item.top + '%'};left:${item.left + '%'};`" @click="goRouter(item.url)">
                    <div class="center_inner_title">{{item.name}}</div>
                </div>
            </template>
        </div>
        <div class="main_content">
            <div class="main_sider">
                <div class="common_top">
                    <div class="elec_title linear_font">{{ $t('mainHome.renewableEnergy') }}</div>
                    <div class="top_cnt">
                        <div class="battery_right_btn">
                            <!-- <div v-for="item in nbqList" :key="item.point_id" :class="[pscType.point_id == item.point_id ? 'change_item change_item_s' : 'change_item change_item_us']" @click="changePSC(item)">
                                {{item.point_name}}
                            </div> -->
                            <div :class="[tyType == 3 ? 'change_item change_item_s' : 'change_item change_item_us']" @click="changeDay(3)">{{ $t('common.day') }}</div>
                            <div :class="[tyType == 2 ? 'change_item change_item_s' : 'change_item change_item_us']" @click="changeDay(2)">{{ $t('common.month') }}</div>
                            <div :class="[tyType == 1 ? 'change_item change_item_s' : 'change_item change_item_us']" @click="changeDay(1)">{{ $t('common.year') }}</div>
                        </div>
                        <div class="top_item">
                            <div class="top_item_cnt">
                                <img src="../../../assets/image/custom/energy_icon1.png"/>
                                <div class="top_item_cnt_right">
                                    <div class="right_item">{{ powerData && powerData.fd_power }} {{ powerData && powerData.power_unit }}</div>
                                    <div class="right_item">{{ $t('mainHome.powerGeneration') }}</div>
                                </div>
                            </div>
                            <div class="top_item_cnt">
                                <img src="../../../assets/image/custom/energy_icon2.png"/>
                                <div class="top_item_cnt_right">
                                    <div class="right_item">{{ powerData && powerData.sw_power }} {{ powerData && powerData.power_unit }}</div>
                                    <div class="right_item">{{ $t('mainHome.powertoGrid') }}</div>
                                </div>
                            </div>
                            <div class="top_item_cnt">
                                <img src="../../../assets/image/custom/energy_icon3.png"/>
                                <div class="top_item_cnt_right">
                                    <div class="right_item">{{ powerData && powerData.xn_rate }} %</div>
                                    <div class="right_item">新能源消纳率</div>
                                </div>
                            </div>
                            <div class="top_item_cnt">
                                <img src="../../../assets/image/custom/energy_icon4.png"/>
                                <div class="top_item_cnt_right">
                                    <div class="right_item">{{ powerData && powerData.xn_power }} {{ powerData && powerData.power_unit }}</div>
                                    <div class="right_item">{{ $t('mainHome.cleanEnergyConsumption') }}</div>
                                </div>
                            </div>
                            <div class="top_item_cnt">
                                <img src="../../../assets/image/custom/energy_icon5.png"/>
                                <div class="top_item_cnt_right">
                                    <div class="right_item" v-if='tyType == 3'>{{tjData[4] || 0}} kWh</div>
                                    <div class="right_item" v-else>{{tjData[4] || 0}} MWh</div>
                                    <div class="right_item">{{ $t('mainHome.peakShavingCapacity') }}</div>
                                </div>
                            </div>
                            <div class="top_item_cnt">
                                <img src="../../../assets/image/custom/energy_icon6.png"/>
                                <div class="top_item_cnt_right">
                                    <div class="right_item" v-if='tyType == 3'>{{tjData[6] || 0}} kWh</div>
                                    <div class="right_item" v-else>{{tjData[6] || 0}} MWh</div>
                                    <div class="right_item">{{ $t('mainHome.EVChargingCapacity') }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="common_other">
                    <div class="elec_title linear_font">{{ $t('mainHome.powerGeneration') }}</div>  
                    <div class="common_area">
                        <v-chart :auto-resize="true" :options="centerBar" ref="centerBar" theme="ovilia-green" />
                    </div>
                </div>
                <div class="common_other">
                    <div class="elec_title linear_font">{{ $t('mainHome.totalPowerConsumption') }}</div>
                    <div class="common_area">
                        <v-chart :auto-resize="true" :options="firstBar" ref="firstBar" theme="ovilia-green" />
                    </div>
                </div>
            </div>
            <div class="main_sider">
                <div class="common_top">
                    <div class="elec_title linear_font">{{ $t('mainHome.powerTransformerLoadRatio') }}</div>
                    <div class="common_area">
                        <div class="sub_area">
                            <img src="../../../assets/image/custom/radio1.png"/>
                            <div class="sub_circle"></div>
                            <div class="sub_name">{{ realTransformerData['1628c53175a14c1094657e5fbe683aad'] && realTransformerData['1628c53175a14c1094657e5fbe683aad'].point_name }}</div>
                            <div class="sub_percent">{{ realTransformerData['1628c53175a14c1094657e5fbe683aad'] && realTransformerData['1628c53175a14c1094657e5fbe683aad'].transformer_rate }}%</div>
                        </div>
                        <el-progress class="my-progress" :percentage="realTransformerData['1628c53175a14c1094657e5fbe683aad'] && realTransformerData['1628c53175a14c1094657e5fbe683aad'].transformer_rate" color="'#409eff'" :show-text="false"></el-progress>
                        <div class="sub_area">
                            <img src="../../../assets/image/custom/radio5.png"/>
                            <div class="sub_circle"></div>
                            <div class="sub_name">{{ realTransformerData['910e4da63a0a40d9afe08338bfa7d68d'] && realTransformerData['910e4da63a0a40d9afe08338bfa7d68d'].point_name }}</div>
                            <div class="sub_percent">{{realTransformerData['910e4da63a0a40d9afe08338bfa7d68d'] && realTransformerData['910e4da63a0a40d9afe08338bfa7d68d'].transformer_rate}}%</div>
                        </div>
                        <el-progress :percentage="realTransformerData['910e4da63a0a40d9afe08338bfa7d68d'] && realTransformerData['910e4da63a0a40d9afe08338bfa7d68d'].transformer_rate" color="'#409eff'" :show-text="false"></el-progress>
                        <div class="sub_area">
                            <img src="../../../assets/image/custom/radio6.png"/>
                            <div class="sub_circle"></div>
                            <div class="sub_name">{{ realTransformerData['9d97ed0be11c4b348a5364a9dadbf1de'] && realTransformerData['9d97ed0be11c4b348a5364a9dadbf1de'].point_name }}</div>
                            <div class="sub_percent">{{realTransformerData['9d97ed0be11c4b348a5364a9dadbf1de'] && realTransformerData['9d97ed0be11c4b348a5364a9dadbf1de'].transformer_rate}}%</div>
                        </div>
                        <el-progress :percentage="realTransformerData['9d97ed0be11c4b348a5364a9dadbf1de'] && realTransformerData['9d97ed0be11c4b348a5364a9dadbf1de'].transformer_rate" color="'#409eff'" :show-text="false"></el-progress>
                        <div class="sub_area">
                            <img src="../../../assets/image/custom/radio2.png"/>
                            <div class="sub_circle"></div>
                            <div class="sub_name">{{ realTransformerData['191e37f359a942f9862aba87d02221d9'] && realTransformerData['191e37f359a942f9862aba87d02221d9'].point_name }}</div>
                            <div class="sub_percent">{{ realTransformerData['191e37f359a942f9862aba87d02221d9'] && realTransformerData['191e37f359a942f9862aba87d02221d9'].transformer_rate }}%</div>
                        </div>
                        <el-progress :percentage="realTransformerData['191e37f359a942f9862aba87d02221d9'] && realTransformerData['191e37f359a942f9862aba87d02221d9'].transformer_rate" color="'#409eff'" :show-text="false"></el-progress>
                        <div class="sub_area">
                            <img src="../../../assets/image/custom/radio4.png"/>
                            <div class="sub_circle"></div>
                            <div class="sub_name">{{ realTransformerData['bf8e8b3939384c6c84881ddd561f3410'] && realTransformerData['bf8e8b3939384c6c84881ddd561f3410'].point_name }}</div>
                            <div class="sub_percent">{{realTransformerData['bf8e8b3939384c6c84881ddd561f3410'] && realTransformerData['bf8e8b3939384c6c84881ddd561f3410'].transformer_rate}}%</div>
                        </div>
                        <el-progress :percentage="realTransformerData['bf8e8b3939384c6c84881ddd561f3410'] && realTransformerData['bf8e8b3939384c6c84881ddd561f3410'].transformer_rate" color="'#409eff'" :show-text="false"></el-progress>
                        <div class="sub_area">
                            <img src="../../../assets/image/custom/radio3.png"/>
                            <div class="sub_circle"></div>
                            <div class="sub_name">{{ realTransformerData['657315dce1fe452bae956adfa962e1c2'] && realTransformerData['657315dce1fe452bae956adfa962e1c2'].point_name }}</div>
                            <div class="sub_percent">{{realTransformerData['657315dce1fe452bae956adfa962e1c2'] && realTransformerData['657315dce1fe452bae956adfa962e1c2'].transformer_rate}}%</div>
                        </div>
                        <el-progress :percentage="realTransformerData['657315dce1fe452bae956adfa962e1c2'] && realTransformerData['657315dce1fe452bae956adfa962e1c2'].transformer_rate" color="'#409eff'" :show-text="false"></el-progress>
                    </div>
                </div>
                <div class="common_other">
                    <div class="elec_title linear_font">{{ $t('mainHome.powerPlantMonthlyConsumption') }}</div>
                    <div class="common_area">
                        <v-chart auto-resize :options="barDepartment" ref="barDepartment" theme="ovilia-green" />
                    </div>
                </div>
                <div class="common_other">
                    <div class="elec_title linear_font">{{ $t('mainHome.carbonNeutral') }}</div>
                    <div class="common_area">
                        <div class="bottom_title">{{ $t('mainHome.realTimeData') }} {{time}}</div>
                        <div class="bottom_div">
                            <div class="bottom_inner">
                                <div class="left">{{ $t('mainHome.energyConsumption') }}</div>
                                <div class="right">{{ tzhData.active_power }}&nbsp;{{ tzhData.active_power_unit }}</div>
                            </div>
                            <div class="bottom_inner">
                                <div class="left">{{ $t('mainHome.coalEquivalent') }}</div>
                                <div class="right">{{ tzhData.tce_power }}&nbsp;{{ tzhData.tce_power_unit }}</div>
                            </div>
                            <div class="bottom_inner">
                                <div class="left">{{ $t('mainHome.CO2Emissions') }}</div>
                                <div class="right">{{ tzhData.tpf_power }}&nbsp;{{ tzhData.tpf_power_unit }}</div>
                            </div>
                        </div>
                        <div class="bottom_title">{{ $t('mainHome.dataTotal') }} {{year}}</div>
                        <div class="bottom_div">
                            <div class="bottom_inner">
                                <div class="left">{{ $t('mainHome.CO2Emissions') }}</div>
                                <div class="right">{{ tzhData.total_tpf_power }}&nbsp;{{ tzhData.total_tpf_power_unit }}</div>
                            </div>
                            <div class="bottom_inner">
                                <div class="left">{{ $t('mainHome.CO2Reduction') }}</div>
                                <div class="right">{{ tzhData.total_tjp_power }}&nbsp;{{ tzhData.total_tjp_power_unit }}</div>
                            </div>
                            <div class="bottom_inner">
                                <div class="left">{{ $t('mainHome.CO2ReductionRate') }}</div>
                                <div class="right">{{ tzhData.total_rate }}{{ tzhData.total_rate_unit }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/pictorialBar";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import 'echarts/lib/component/legendScroll';
import * as api from "@/http/api.js";
import moment from "moment";
import utils from "@/utils/utils";
export default {
    data() {
        return {
            itemStyleList: [
                 {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgba(155, 226, 246, 1)'
                        }, {
                            offset: 1,
                            color: 'rgba(155, 226, 246, 0.3)'
                        }]),
                    }
                },
                {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgba(88, 183, 246, 1)'
                        }, {
                            offset: 1,
                            color: 'rgba(88, 183, 246, 0.3)'
                        }]),
                    }
                },
                {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgba(25, 125, 246, 1)'
                        }, {
                            offset: 1,
                            color: 'rgba(25, 125, 246, 0.3)'
                        }]),
                    }
                },
                {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgba(0, 255, 252, 1)'
                        }, {
                            offset: 1,
                            color: 'rgba(0, 255, 252, 0.3)'
                        }]),
                    }
                },
                {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgba(40, 187, 129, 1)'
                        }, {
                            offset: 1,
                            color: 'rgba(40, 187, 129, 0.3)'
                        }]),
                    }
                },
                {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgba(212, 52, 72, 1)'
                        }, {
                            offset: 1,
                            color: 'rgba(212, 52, 72, 0.3)'
                        }]),
                    }
                },
            ],
            hoverType: '0',
            picData: [
                {
                    hoverType: 'switch_station',
                    top: 28,
                    left: 30,
                    staticClass: 'switch_station',
                    hoverClass: 'switch_station switch_station_hover',
                    url: '',
                    name: this.$t('mainHome.switchStation')
                },
                {
                    hoverType: 'battery',
                    top: 44,
                    left: 42,
                    staticClass: 'battery',
                    hoverClass: 'battery battery_hover',
                    url: '/elec_station_manage',
                    name: this.$t('mainHome.battery')
                },
                {
                    hoverType: 'evc',
                    top: 40.5,
                    left: 55,
                    staticClass: 'evc',
                    hoverClass: 'evc evc_hover',
                    url: '/elec_charge_manage',
                    name: this.$t('mainHome.evc')
                },
                {
                    hoverType: 'pv',
                    top: 25.5,
                    left: 60,
                    staticClass: 'pv',
                    hoverClass: 'pv pv_hover',
                    url: '/roof_manage',
                    name: this.$t('mainHome.pv')
                }
            ],
            disableDate: {
                disabledDate: time => {
                    return (
                        time.getTime() >
                        new Date(
                            new Date(this.sysdate).toLocaleDateString()
                        ).getTime()
                    );
                }
            },
            searchForm: {
                elecDept: ''
            },
            searchForm1: {
                time: moment().format('YYYY')
            },
            cdl_type: 1,
            yd_type: 1,
            tyType: 1, //1年数据统计 2月数据统计 3日数据统计
            tyData: [],
            tjYearData: ['400万', '12万', '97', '388万','0','730','0','2008'],
            tjMonthData: ['33万', '9000', '97.3', '32.1万','0','60','0','212'],
            tjDayData: ['1万', '280', '97.2', '9720','0','2','0','11'],
            time: '',
            year: '',
            tzhData: {},
            realMonthData: {},
            realTransformerData: {},
            fdlData: {},
            powerDataBasic: {},
            powerData: {},
            deptElecData: [],
            deptElecData_x: [],
            monthDeptPowerData: [],
            dept_growth_rate_list: [],
            dept_x_list: [],
            dept_tq_list: [],
            dept_bq_list: [],
            timer: null,
        };
    },
    created() {
        // this.initData();
    },
    mounted() {
        this.initData();
        this.setTimer();
    },
    methods: {
        initData() {
            this.getRealMonthData();
            this.getMonthDeptPowerComparison();
            this.getRealTransformerData();
            this.getRealCarbon();
            this.getRealTimeGfPower();
            this.tjData = this.tjYearData;
            this.time = moment().format('YYYY-MM-DD HH:mm');
            this.year = moment().format('YYYY');
            this.getPowerComparison();
            // this.getDeptPowerComparison();
            // this.getMonthDeptPowerComparison();
            // this.getIndexDeptList();
        },
        toggleColor(type, shown) {
            if(shown) this.hoverType = type;
            else this.hoverType = '';
        },
        goRouter(url) {
            if(url) this.$store.dispatch("getMenuInfo", url);
        },
        hoverPic(type) {
            this.hoverType = type;
        },
        resetHoverPic() {
            this.hoverType = 0;
        },
        changeDay(type) {
            this.tyType = type;
            if(type == 1) {
                this.tjData = this.tjYearData;
                this.powerData = this.powerDataBasic && this.powerDataBasic.year;
            }
            else if(type == 2) {
                this.tjData = this.tjMonthData;
                this.powerData = this.powerDataBasic && this.powerDataBasic.month;
            }
            else {
                this.tjData = this.tjDayData;
                this.powerData = this.powerDataBasic && this.powerDataBasic.day;
            }
        },
        getSingleDeptPowerComparison() {
            api.getSingleDeptPowerComparison({ tree_unit_id: this.searchForm.elecDept }).then(res => {
                if (res && res.error_code == 0) {
                    this.dept_growth_rate_list = res.bus_json.growth_rate_list;
                    this.dept_x_list = res.bus_json.time_list;
                    this.dept_tq_list = res.bus_json.tq_list;
                    this.dept_bq_list = res.bus_json.bq_list;
                }
            });
        },
        getIndexDeptList() {
            api.getIndexDeptList().then(res => {
                if (res && res.error_code == 0) {
                    this.deptList = res.bus_json;
                    if(this.deptList && this.deptList.length) {
                        this.searchForm.elecDept = this.deptList[0].tree_unit_id;
                        this.getSingleDeptPowerComparison();
                    }
                }
            });
        },
        getMonthDeptPowerComparison() {
            api.getMonthDeptPowerComparison({show_year: this.searchForm1.time}).then(res => {
                if (res && res.error_code == 0) {
                    this.monthDeptPowerData = res.bus_json;
                    const series = [];
                    this.monthDeptPowerData && this.monthDeptPowerData.legend && this.monthDeptPowerData.legend.forEach((item, index) => {
                        series.push(
                            {
                                name: item,
                                type: "bar",
                              //  stack: "one",
                               // barWidth: 10,
                               itemStyle: this.itemStyleList[index%6],
                                data: this.monthDeptPowerData.y_list[index],
                            },
                        )
                    })
                    this.monthDeptPowerData['series'] = series;
                }
            });
        },
        getDeptPowerComparison() {
            api.getDeptPowerComparison({show_year: this.searchForm1.time}).then(res => {
                if (res && res.error_code == 0) {
                    this.deptElecData = [];
                    this.deptElecData_x = res.bus_json.dept_name;
                    res.bus_json.dept_name && res.bus_json.dept_name.forEach((item, index)=> {
                        this.deptElecData.push({
                            name: item,
                            value: res.bus_json.active_power[index]
                        })
                    })
                }
            });
        },
        getEqualNewlineString (params, length) {
            let text = ''
            let count = Math.ceil(params.length / length) // 向上取整数
            // 一行展示length个
            if (count > 1) {
                for (let z = 1; z <= count; z++) {
                text += params.substr((z - 1) * length, length)
                if (z < count) {
                    text += '\n'
                }
                }
            } else {
                text += params.substr(0, length)
            }
            return text
        },
        getPowerComparison() {
            api.getPowerComparison().then(res => {
                if (res && res.error_code == 0) {
                    this.fdlData = res.bus_json;
                }
            });
        },
        getRealTimeGfPower() {
            api.getRealTimeGfPower().then(res => {
                if (res) {
                    this.powerDataBasic = res.bus_json;
                    this.powerData = this.powerDataBasic && this.powerDataBasic.year;
                }
            });
        },
        getRealTransformerData() {
            api.getRealTransformerData().then(res => {
                if (res && res.error_code == 0) {
                    this.realTransformerData = res.bus_json;
                }
            });
        },
        getRealMonthData() {
            api.getRealMonthData({point_id: '000001'}).then(res => {
                if (res && res.error_code == 0) {
                    this.realMonthData = res.bus_json;
                }
            });
        },
        getRealCarbon() {
            api.getRealCarbon({point_id: '000001'}).then(res => {
                if (res && res.error_code == 0) {
                    this.tzhData = res.bus_json;
                }
            });
        },
        changeElecDept(e) {
            this.getSingleDeptPowerComparison();
        },
        handleSearchReport() {
            this.getDeptPowerComparison();
        },
        clickTj(type) {
            this.tyType = type;
            if(type == 1) {
                this.tjData = this.tjYearData;
                this.powerData = this.powerDataBasic && this.powerDataBasic.year;
            }
            else if(type == 2) {
                this.tjData = this.tjMonthData;
                this.powerData = this.powerDataBasic && this.powerDataBasic.month;
            }
            else {
                this.tjData = this.tjDayData;
                this.powerData = this.powerDataBasic && this.powerDataBasic.day;
            }
        },
        getRandom(num) {
            let arr = [];
            for (let i = 0; i < num; i++) {
                var random1 = (Math.random() * (150)).toFixed(2);
                arr.push(random1)
            }
            return arr;
        },
        getSysDate() {
            api.getSysDate1().then(res => {
                if (res && res.error_code == 0) {
                    this.getCurrentElecList(res.bus_json.sysdate3);
                    this.getCurrentMonthsFdl(res.bus_json.sysdate3);
                }
            });
        },
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.initData();
            }, 1000 * 60);
        },
    },
    watch: {
        language() {
            return this.$store.state.language.language;
        },
    },
    computed: {
        language() {
            return this.$store.state.language.language;
        },
        centerBar() {
            const option = {
                grid: {
                    left: "1%",
                    right: "3%",
                    bottom: "3%",
                    top: "15%",
                    containLabel: true
                },
                color: ["#1593CE", "#CE720b"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    }
                },
                xAxis: [
                    {
                        type: "category",
                        axisTick: { show: false },
                        data: this.fdlData.time_list,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "MWh",
                        type: "value",
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    },
                ],
                series: [
                    {
                        // name: "今年",
                        name: this.$t('mainHome.powerGeneration'),
                        //type: "bar",
                        type: 'pictorialBar',
                        // barCategoryGap： 同一系列的柱间距离，默认为类目间距的20%，可设固定值
                        barCategoryGap: '-100%',
                        symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
                        barWidth: 30,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                                    offset: 0,
                                    color: 'rgba(80, 127, 173, 1)'
                                }, {
                                    offset: 0.3,
                                    color: 'rgba(52, 129, 220, 1)'
                                }, {
                                    offset: 1,
                                    color: '#000'
                                }]),
                                barBorderRadius: [10, 10, 0, 0],
                                // borderWidth: 1,
                                // borderColor: '#fff'
                            },
                            emphasis: {
                                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                                    offset: 0,
                                    color: 'rgba(80, 127, 173, 1)'
                                }, {
                                    offset: 0.3,
                                    color: 'rgba(44, 136, 105, 1)'
                                }, {
                                    offset: 1,
                                    color: '#000'
                                }]),
                            },
                        },
                        data: this.fdlData.bq_power_list
                    },
                ]
            };
            return option;
        },
        firstBar() {
            const options = {
                // 坐标轴
                grid: {
                    top: "0%",
                    left: "5%",
                    right: "16%",
                    bottom: "3%",
                    containLabel: true, //是否包含坐标轴的文字
                },
                // X轴：横向柱状图，将xAxis的type设置为value
                xAxis: {
                    name: 'MWh',
                    type: "value",
                    nameTextStyle: {
                        color: "#fff",
                        fontSize: 10
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        //x轴文字的配置
                        show: false,
                        textStyle: {
                            color: "#fff",
                            fontSize: 10
                        }
                    },
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "" // 颜色
                        }
                    },
                    splitLine: {
                        show: false,
                        lineStyle: {
                            color: "" // 颜色
                        }
                    }
                },
                // Y轴：横向柱状图，将xAxis的type设置为category
                yAxis: {
                    type: "category",
                    data: this.realMonthData.show_month,
                    nameTextStyle: {
                        color: "#fff",
                        fontSize: 10
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        //x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#fff",
                            fontSize: 10
                        }
                    },
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "" // 颜色
                        }
                    },
                    splitLine: {
                        show: false,
                        lineStyle: {
                            color: "" // 颜色
                        }
                    }
                },
                // 图表内容
                series: [
                    {
                        type: "bar", // 图表类型
                        data: this.realMonthData.datalist, // 数据
                        barWidth: 8, // 柱的宽度
                        // 柱上面的数值配置
                        label: {
                            show: true, // 显示值
                            position: "right", // 显示位置
                            color: "white",
                            fontSize: 10,
                            formatter: function(params) {
                                return String(params.value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                            }
                        },
                        // 每一个条目的样式配置
                        itemStyle: {
                            barBorderRadius: [0, 34, 34, 0], // 圆角
                            // 渐变色  1、指明颜色渐变的方向  2、指明不同百分比之下颜色的值
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                { offset: 0, color: "rgba(19, 67, 108, 1)" },
                                { offset: 1, color: "rgba(167, 209, 254, 1)" },
                            ]),
                        },
                    },
                ],
            };
            return options;
        },
        barDepartment() {
            const options = {
            //    color: [],
                grid: {
                    left: "5%",
                    right: "3%",
                    bottom: "3%",
                    top: "15%",
                    containLabel: true
                },
                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                color: ["#5afbf4", "#107e8c", "#0796d6", "#596376","#035465", "#013f56", "#1aada7", "#1f6781", "#5197a0", "#217398", "#427756"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "",
                        // axisLabel: {
                        //     rotate: -45,
                        // },
                        data: this.monthDeptPowerData && this.monthDeptPowerData.time_list,
                        // axisLabel: {
                        //     rotate: -45,
                        //     //y轴文字的配置
                        //     textStyle: {
                        //         color: utils.getFontColor()
                        //     }
                        // },
                        // axisLine: {
                        //     lineStyle: {
                        //         color: utils.getFontColor() // 颜色
                        //     }
                        // },
                        
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "kWh",
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: this.monthDeptPowerData.series,
            };
            return options;
        },
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.main_index {
    width: 100%;
    height: calc(100% + #{px2Rem(45px)} + 5rem);
    // background: url("../../../assets/image/custom/main_index_bg.jpg") no-repeat;
    // -webkit-background-size: 100% auto;
    // background-size: 100% auto;
    margin-top: -4.5rem;
    color: rgba(255, 255, 255, 1);
    position: relative;
    .main_back_div {
        width: 100%;
        position: relative;
        .main_back_img {
            width: 100%; 
            height: auto;
        }
        .zhizhen {
            height: 4rem;
            position: absolute; 
            top: -60%;
            left: 40%;
        }
        .zhizhen_back {
            height: 2.8rem;
            position: absolute; 
            top: -80%;
            left: 40%;
        }
        .pv_zhizhen_back {
            top: 41%;
            left: 63%;
        }
        .title_icon {
            height: 1.7rem;
            position: absolute; 
            top: -64%;
            // left: 65%;
        }
        .title_name {
            font-size: 0.9rem;
            height: 2.8rem; 
            line-height:2.8rem; 
            width: 10rem; 
            position: absolute; 
            top: -77.5%;
            // left: 100%;
        }
        .pv_title_name {
            top: 41.5%;
            left: 70%;
        }
        .pv_zhizhen {
            top: 47%;
            left: 62%;
        }
        .pv_title_icon {
            top: 45%;
            left: 65%;
        }
    }
    .right_top1_static {
        position: absolute; 
        top: 16%;
        left: 33.8%; 
        z-index: 11; 
        width: 50.5rem;
        height: 15rem;
        // background: url('../../../assets/image/custom/right_top_hover1.png') no-repeat;
        // background-size: 100% 100%;
    }
    .right_top1 {
        // position: absolute; 
        // top: 16%;
        // left: 33.8%; 
        // z-index: 11; 
        // width: 50.5rem;
        // height: 15rem;
        background: url('../../../assets/image/custom/right_top_hover1.png') no-repeat;
        background-size: 100% 100%;
    }
    .right_top2_static {
        position: absolute; 
        top: 42.3%;
        left: 62%; 
        z-index: 11; 
        width: 22rem;
        height: 6rem;
        // background: url('../../../assets/image/custom/right_top_hover2.png') no-repeat;
        // background-size: 100% 100%;
    }
    .right_top2 {
        // position: absolute; 
        // top: 42.3%;
        // left: 62%; 
        // z-index: 11; 
        // width: 22rem;
        // height: 6rem;
        background: url('../../../assets/image/custom/right_top_hover2.png') no-repeat;
        background-size: 100% 100%;
    }
    .center_inner_title {
        font-weight: 600;
        font-size: 0.8rem;
        letter-spacing: 0.03em;
        position: absolute;
        text-align: center;
    }
    .switch_station {
        width: 11.5rem;
        height: 5.2rem;
        z-index: 11;
        background: url("../../../assets/image/custom/switch_station_s.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        div {
            top: 0.75rem;
            left: 3.2rem;
            width: 8rem;
           // border: 1px solid red;
        }
    }
    .switch_station_hover {
        background: url("../../../assets/image/custom/switch_station_us.png") no-repeat;
        background-size: 100% 100%;
    }
    .evc {
        width: 7.9rem;
        height: 5.2rem;
        z-index: 11;
        background: url("../../../assets/image/custom/evc_s.png") no-repeat;
        background-size: 100% 100%;
        div {
            top: 0.9rem;
            left: 1.8rem;
            width: 3rem;
            //border: 1px solid red;
        }
    }
    .evc_hover {
        background: url("../../../assets/image/custom/evc_us.png") no-repeat;
        background-size: 100% 100%;
    }
    .battery {
        width: 12rem;
        height: 5.2rem;
        z-index: 11;
        background: url("../../../assets/image/custom/battery_s.png") no-repeat;
        background-size: 100% 100%;
        div {
            top: 0.75rem;
            left: 4.2rem;
            width: 5.8rem;
         //   border: 1px solid red;
        }
    }
    .battery_hover {
        background: url("../../../assets/image/custom/battery_us.png") no-repeat;
        background-size: 100% 100%;
    }
    .pv {
        width: 7.9rem;
        height: 5.2rem;
        z-index: 11;
        background: url("../../../assets/image/custom/pv_s.png") no-repeat;
        background-size: 100% 100%;
        div {
            top: 0.9rem;
            left: 4.5rem;
            width: 3rem;
          //  border: 1px solid red;
        }
    }
    .pv_hover {
        background: url("../../../assets/image/custom/pv_us.png") no-repeat;
        background-size: 100% 100%;
    }
    // .switch_station {
    //     width: 4.5rem;
    //     height: 3.5rem;
    //     z-index: 11;
    // }
    // .switch_station_hover {
    //     background: url("../../../assets/image/custom/switch_station.png") no-repeat;
    //     background-size: 100% 100%;
    // }
    // .evc {
    //     width: 4.5rem;
    //     height: 3rem;
    //     z-index: 11;
    // }
    // .evc_hover {
    //     background: url("../../../assets/image/custom/evc_hover.png") no-repeat;
    //     background-size: 100% 100%;
    // }
    // .battery {
    //     width: 5.5rem;
    //     height: 3.4rem;
    //     z-index: 11;
    // }
    // .battery_hover {
    //     background: url("../../../assets/image/custom/battery_hover.png") no-repeat;
    //     background-size: 100% 100%;
    // }
    .el-progress-bar__inner {
        background: linear-gradient(to right, rgba(110, 222, 169, 1), rgb(225, 247, 236)) !important;
    }
    .el-progress-bar__outer {
        height: 3px !important;
        background-color: rgba(110, 222, 169, 0.2) !important;
    }
    .main_content {
        position: absolute;
        top: 3.5rem;
        left: 0;
        width: 100%;
        height: calc(100% - 3.5rem);
       // text-align: center;
        background-position: top center;
        padding: 0 1rem;
        box-sizing: border-box;
        display: inline-flex;
        justify-content: space-between;
        z-index: 9;
        .main_sider {
            width: 20%;
            height: 100%;
            display: inline-flex;
            flex-flow: column;
            justify-content: space-around;
        }
        .common_top {
            width: 100%;
            height: 34%;
            background: url("../../../assets/image/custom/title_wrapper.png") no-repeat;
            background-size: 100% auto;
            position: relative;
            .top_item {
                width: 100%;
                height: calc(100% - 2rem);
                display: inline-flex;
                flex-flow: row wrap;
                align-items: center;
                justify-content: space-evenly;
                .top_item_cnt {
                    width: 50%;
                    height: 32%;
                    display: inline-flex;
                    align-items: center;
                    padding: 0 0.5rem;
                    box-sizing: border-box;
                    img {
                        width: 2rem;
                        height: 2rem;
                    }
                    .top_item_cnt_right {
                        flex: 1;
                        display: inline-flex;
                        align-items: center;
                        flex-flow: column;
                        margin-left: 0.2rem;
                        .right_item {
                            width: 100%;
                            height: 48%;
                            font-size: 0.75rem;
                        }
                    }
                }
            }
            .top_cnt {
                position: absolute;
                top: 14%;
                left: 0;
                width: 100%;
                height: 86%;
                .battery_right_btn {
                    width: 100%;
                    display: inline-flex;
                    align-items: center;
                    justify-content: flex-end;
                    .change_item {
                       // width: 2.5rem;
                       padding: 0 0.6rem;
                        height: 1.1rem;
                        line-height: 1.1rem;
                        font-size: 0.7rem;
                        text-align: center;
                        cursor: pointer;
                      //  margin-left: 2px;
                    }
                    .change_item_s {
                        color: rgba(31, 133, 255, 1);
                        border: 1px solid rgba(31, 133, 255, 1);
                      //  border-radius: 5px;
                    }
                    .change_item_us {
                        color: #aaaaaa;
                        border: none;//1px solid #F3F3F3;
                    }
                }
            }
        }
        .common_other {
            width: 100%;
            height: 31%;
            background: url("../../../assets/image/custom/title_wrapper.png") no-repeat;
            background-size: 100% auto;
            position: relative;
        }
        .common_area {
          //  border: 1px solid red;
            position: absolute;
            top: 17%;
            width: 100%;
            height: 83%;
            box-sizing: border-box;
            padding: 0 0.5rem;
            .echarts {
                width: 100%;
                height: 100%;
            }
            .bottom_title {
                width: 100%;
                height: 12.5%;
                background-color: rgba(15, 73, 123, 0.3);
                text-align: center;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: rgba(109, 191, 255, 1);
                font-size: 0.75rem;
            }
            .bottom_div {
                width: 100%;
                height: 37.5%;
                display: inline-flex;
                flex-flow: column;
                align-items: center;
                font-size: 0.7rem;
                .bottom_inner {
                    flex: 1;
                    width: 100%;
                    display: inline-flex;
                    flex-flow: row;
                    align-items: center;
                    &:nth-child(2n) {
                        background-color: rgba(15, 73, 123, 0.3);
                    }
                    &:nth-child(2n+1) {
                        background-color: transparent;
                    }
                    .left {
                        flex: 1;
                        color: #aaa;
                    }
                    .right {
                        flex: 1;
                        text-align: center;
                    }
                }
            }
            .sub_area {
                width: 100%;
                height: calc(16.6% - 3px);
                display: inline-flex;
                align-items: center;
                font-size: 0.75rem;
                img {
                    width: 1.6rem;
                    height: auto;
                }
                .sub_circle {
                    width: 0.3rem;
                    height: 0.3rem;
                    border-radius: 0.3rem;
                    background-color: rgba(123, 225, 177, 1);
                    margin-left: 0.5rem;
                }
                .sub_name {
                    width: 50%;
                    height: 100%;
                    margin-left: 0.3rem;
                    display: inline-flex;
                    align-items: center;
                }
                .sub_percent {
                    flex: 1;
                    text-align: right;
                }
            }
        }
        .elec_title {
            position: absolute;
            top: 4.5%;
            left: 18%;
          //  color: rgba(148, 194, 232, 1);
            font-size: 0.8rem;
        }
    }
    i {
        color: rgba(109, 191, 255, 1);
    }
    .leader-style-form {
        margin-bottom: 0 !important;
    }
    .leader-style-form .el-input__inner {
        height: 1.4rem !important;
        line-height: 1.4rem !important;
    }
    .el-input__icon {
        line-height: 1.4rem !important;
    }
    .leader-common-button {
        padding: 0.6rem !important;
        border-radius: 0.3rem !important;
        font-size: 0.7rem !important;
        height: auto !important;
    }
    .leader-style-form .el-form-item__label {
        font-size: 0.8rem !important;
    }
}
</style>
